import trackAppleTVGallerySlideClose from '../track-event/apple-tv-gallery-slide-close';
import trackAppleTVGallerySlideOpen from '../track-event/apple-tv-gallery-slide-open';
import trackAppleTVGallerySlideView from '../track-event/apple-tv-gallery-slide-view';
import trackAppleTVGallerySlideInaction, { EVENT_NAME as SCREENSHOT_INACTION_EVENT_NAME } from '../track-event/apple-tv-gallery-slide-inaction';
import galleryTracker from './_gallery';



export default galleryTracker({
  SCREENSHOT_INACTION_EVENT_NAME,
  trackSlideView: trackAppleTVGallerySlideView,
  trackSlideOpen: trackAppleTVGallerySlideOpen,
  trackSlideClose: trackAppleTVGallerySlideClose,
  trackSlideInaction: trackAppleTVGallerySlideInaction
});



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/apple-tv-gallery.js